/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ValidatorWithTVLCap } from "../ValidatorWithTVLCap";

export class ValidatorWithTVLCap__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ValidatorWithTVLCap> {
    return super.deploy(overrides || {}) as Promise<ValidatorWithTVLCap>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ValidatorWithTVLCap {
    return super.attach(address) as ValidatorWithTVLCap;
  }
  connect(signer: Signer): ValidatorWithTVLCap__factory {
    return super.connect(signer) as ValidatorWithTVLCap__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ValidatorWithTVLCap {
    return new Contract(address, _abi, signerOrProvider) as ValidatorWithTVLCap;
  }
}

const _abi = [
  {
    inputs: [],
    name: "capFactor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "startTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "startingCap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x6080604052348015600f57600080fd5b5060a18061001e6000396000f3fe6080604052348015600f57600080fd5b5060043610603c5760003560e01c80630b06528714604157806378e9792514605b578063ad45ed96146063575b600080fd5b604960025481565b60405190815260200160405180910390f35b604960005481565b60496001548156fea2646970667358221220dcbdfa12b4764e78738642d4de0c0f2c398d9c58c065fafbd6b5387c9af8772c64736f6c63430008020033";
